export default "https://cdn-static.gokick.com/assets/efda86aac2f53028585758eeb3b3c0048c8387b3/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";